<template>
  <b-tab title="Faturamentos" class="m-0 p-0">
    <div class="tab-screen-list-alt">
      <!-- :::::::::::::::::::::::::::: TABELA DE FATURAMENTOS :::::::::::::::::::::::::::: -->
      <b-table
        id="table-fat"
        ref="tabelaFaturamento"
        bordered
        hover
        small
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :items="getFilterFaturamentos(filtro)"
        :fields="fields.faturamento"
      >
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(total)="data">
          <div>
            <p>{{ formatter.format(data.item.total) }}</p>
          </div>
        </template>
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="gerarOs(data.item)" v-b-tooltip.hover title="Gerar OS">
              <b-icon icon="file-earmark-post-fill" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-form-input
              id="fat-filter-id"
              type="number"
              size="sm"
              variant="warning"
              class="m-1 p-1"
              placeholder="Id"
              v-model="filtro.id"
            />
            <b-form-input
              id="fat-filter-desc"
              type="search"
              size="sm"
              variant="warning"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="fat-filter-cliente"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Cliente"
              v-model="filtro.cliente"
            />
            <b-form-input
              id="fat-filter-orc"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Orçamento"
              v-model="filtro.orcamento"
            />
            <b-form-input id="fat-filter-nota" type="search" size="sm" class="m-1 p-1" placeholder="Nota" v-model="filtro.nota" />

            <b-pagination
              class="m-1 ml-2"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-fat"
              limit="3"
              size="sm"
            ></b-pagination>
            <b-button size="sm" class="m-1" variant="light">
              {{ rows + " itens" }}
            </b-button>
          </b-form>
        </b-col>
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" @click="relatorio()">
              <b-icon icon="file-earmark-post-fill" variant="light" scale="1.1" class="mr-2" />Relatório
            </b-button>
          </b-form>
        </b-col>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <faturamento-modal ref="editorFaturamento" @focarItemDaTabela="focarItemDaTabela($event)" />
    <os-modal ref="gerarOrdemDeServico" />
    <relatorio-faturamento-modal ref="relatorioFaturamento" />
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useFaturamentoStore } from "@/stores/FaturamentoStore";
import Faturamento from "@/models/Faturamento";
import TableFields from "@/tools/TableFields";
import FaturamentoModal from "@/components/modals/faturamento/FaturamentoModal";
import OrdemServicoModal from "@/components/modals/faturamento/OrdemServicoModal";
import RelatorioFaturamentoModal from "@/components/modals/faturamento/RelatorioFaturamentoModal";

export default {
  name: "EquipamentoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        id: "",
        descricao: "",
        cliente: "",
        orcamento: "",
        nota: "",
        pago: null,
      },
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
      faturamento: new Faturamento(0, "Novo Faturamento", "", "", new Date(), "", 0.0, false),
      perPage: 50,
      currentPage: 1,
    };
  },

  components: {
    "faturamento-modal": FaturamentoModal,
    "os-modal": OrdemServicoModal,
    "relatorio-faturamento-modal": RelatorioFaturamentoModal,
  },

  computed: {
    rows() {
      return this.getFilterFaturamentos(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.faturamento = new Faturamento(0, "Novo Faturamento", "", "", new Date(), "", 0.0, false);
      this.$refs.editorFaturamento.call(this.faturamento);
    },

    editar(faturamento) {
      this.$refs.editorFaturamento.call(faturamento);
    },

    gerarOs(faturamento) {
      this.$refs.gerarOrdemDeServico.call(faturamento);
    },

    relatorio() {
      this.$refs.relatorioFaturamento.call();
    },

    focarItemDaTabela(faturamento) {
      this.filtro.id = faturamento.id;
      this.filtro.descricao = "";
      this.filtro.cliente = "";
      this.filtro.orcamento = "";
      this.filtro.nota = "";
    },
  },

  setup() {
    const store = useSgcqStore();
    const faturamentoStore = useFaturamentoStore();
    const { getFilterFaturamentos } = storeToRefs(faturamentoStore);

    return {
      store,
      faturamentoStore,
      getFilterFaturamentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#fat-filter-id {
  width: 6rem;
}
#fat-filter-desc {
  width: 16rem;
}
#fat-filter-cliente {
  width: 16rem;
}
#fat-filter-orc {
  width: 8rem;
}
#fat-filter-nota {
  width: 8rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
